import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PoComboOption, PoNotificationService } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { Observable } from 'rxjs';
import { LiteralsWords } from 'src/app/i18n/literals.model';
import { environment } from 'src/environments/environment';
import { ITypesOfOperationAPI, ITypesOfOperationCombo } from '../interfaces/typesOfOperation.model';
import { LiteralsService } from './literals-service';
import { NetworkService } from './network.service';

@Injectable({
  providedIn: 'root'
})
export class TypesOfOperationService {
  literals: LiteralsWords;
  typesOfOperation = 'typesOfOperation';

  constructor(
    private http: HttpClient,
    private literalsService: LiteralsService,
    private poNotificationService: PoNotificationService,
    private poStorageService: PoStorageService,
    private networkService: NetworkService
  ) {
    this.literals = this.literalsService.getLiteralModule();
  }

  getAll(): Observable<ITypesOfOperationAPI> {
    return this.http.get<ITypesOfOperationAPI>(`${environment.url}api/tgv/typesofoperation`);
  }

  async setStorage(): Promise<void> {
    this.getAll().subscribe({
      next: res => {
        const comboOptions: PoComboOption[] = res.items.map(types => ({
          ...types,
          label: types.operationtypeid + ' - ' + types.description,
          value: types.operationtypeid
        }));
        this.poStorageService.set(this.typesOfOperation, comboOptions);
      },
      error: err => this.poNotificationService.error(err)
    });
  }

  async getTypesOfOperationsComboStorage(): Promise<ITypesOfOperationCombo[]> {
    const comboOptions: PoComboOption[] = [];

    if (this.networkService.getConnectionStatus().status) {
      await this.setStorage();
    }

    return await this.poStorageService
      .exists(this.typesOfOperation)
      .then(async exist => {
        if (exist) {
          return await this.poStorageService.get(this.typesOfOperation);
        }
        return comboOptions;
      })
      .catch(error => this.poNotificationService.error(error));
  }

  async getDefaultOperationTypeFromStorage(): Promise<string> {
    return await new Promise((resolve, reject) => {
      this.poStorageService
        .get('MV_PGVTPOP')
        .then(res => resolve(res || ''))
        .catch(() => {
          this.poNotificationService.error(this.literals.str0674);
          reject('');
        });
    });
  }
}
